import React from 'react';
import { Loader2, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

const LeadsTable = ({ leads, loading, onDelete }) => {
  if (loading) return <div className="p-10 text-center text-slate-400"><Loader2 className="w-5 h-5 animate-spin inline" /> Loading...</div>;
  if (leads.length === 0) return <div className="p-10 text-center text-slate-400">No leads yet.</div>;
  return (
    <table className="w-full text-sm">
      <thead className="bg-slate-900/60 text-slate-400 text-xs uppercase tracking-wider">
        <tr>
          <th className="text-left px-5 py-3">Name</th>
          <th className="text-left px-5 py-3">Email</th>
          <th className="text-left px-5 py-3">Company</th>
          <th className="text-left px-5 py-3">Source</th>
          <th className="text-left px-5 py-3">Message</th>
          <th className="text-left px-5 py-3">When</th>
          <th className="text-right px-5 py-3">Actions</th>
        </tr>
      </thead>
      <tbody>
        {leads.map(l => (
          <tr key={l.id} className="border-t border-cyan-400/5 hover:bg-slate-900/40 align-top">
            <td className="px-5 py-4 text-white">{l.name}</td>
            <td className="px-5 py-4 text-cyan-300"><a href={`mailto:${l.email}`} className="hover:underline">{l.email}</a></td>
            <td className="px-5 py-4 text-slate-300">{l.company}</td>
            <td className="px-5 py-4"><span className="text-xs px-2 py-1 rounded bg-cyan-400/10 text-cyan-300 border border-cyan-400/20 capitalize">{l.source}</span></td>
            <td className="px-5 py-4 text-slate-400 max-w-md"><div className="line-clamp-2">{l.message}</div></td>
            <td className="px-5 py-4 text-slate-400 text-xs whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</td>
            <td className="px-5 py-4 text-right"><Button onClick={() => onDelete && onDelete(l)} variant="outline" className="h-8 border-red-900/40 bg-transparent hover:bg-red-950/40 text-red-300"><Trash2 className="w-3.5 h-3.5" /></Button></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default LeadsTable;
